import { formatDateCustom, formatDateDisplay, formatDateTimeWorded } from '@/utils/date';

import { type AuditMessage, auditMessage } from './text';
import type { AuditLogFilters } from './types';

/** How far either side of an entry the "Show ±5 minutes" pivot looks. */
export const AUDIT_TIME_WINDOW_MINUTES = 5;

export interface AuditTimeDescription {
    /** HH:mm:ss, local. */
    time: string;
    /** DD/MM/YYYY, local. */
    date: string;
    /** Local time plus the UTC instant to the millisecond, to match against server logs. */
    title: AuditMessage;
}

export function describeAuditTime(occurredAt: Date): AuditTimeDescription {
    return {
        time: formatDateCustom(occurredAt, 'HH:mm:ss'),
        date: formatDateDisplay(occurredAt),
        title: auditMessage('auditLog.time.title', {
            local: formatDateTimeWorded(occurredAt),
            utc: occurredAt.toISOString(),
        }),
    };
}

/**
 * What else happened around an entry, by anyone: a failed sign-in shortly before a
 * change, or the other writes of a burst.
 */
export function auditTimeWindow(occurredAt: Date): AuditLogFilters {
    const width = AUDIT_TIME_WINDOW_MINUTES * 60 * 1000;
    return {
        from: new Date(occurredAt.getTime() - width),
        to: new Date(occurredAt.getTime() + width),
    };
}
